module.exports = __webpack_public_path__ + "static/media/icon_miniarrow_up_down.dd143708.svg";